import { useState, useEffect } from "react";

import RedAccordianArrowDown from "../../Assets/Images/AccordianArrowDown.svg";
import AccordianArrowUp from "../../Assets/Images/AccordianArrowUp.svg";
import WhyListIcon from "../../Assets/Images/about-list-shape-icon.svg";
import { useAnimateOnScroll } from "../../Hooks/useAnimationScroll";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const InternationalClientsData = () => {
  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [openPanels, setOpenPanels] = useState({
    panel1: false,
    panel2: true,
  });

  const togglePanel = (panel) => {
    setOpenPanels((prev) => ({ ...prev, [panel]: !prev[panel] }));
  };

  const translations = useTranslation(); // Get translations dynamically
    useAnimateOnScroll();

  return (
    <div
      id="Afibl"
      className=" accordion-main lg:pt-2 lg:pb-10 md:pb-[2rem] pt:2"
    >
        <div className="flex flex-col lg:flex-row gap-8 lg:px-0 px-4">
          {/* Left Section */}

          {/* Right Section */}
          <div className="py-0 md:py-8 lg:py-16 max-w-[530px] international-client-content-wrap">
            {/* Title only at lg+ — at <lg the title lives in About.jsx wrapper above the image */}
            <div className="hidden lg:block">
              <h2 className="lg:text-[30px] lg:leading-[33px] xl:text-[40px] xl:leading-[44px] font-bold mb-6 FAQheading extra-title-heading">
                {translations.internationalHeading}
              </h2>
            </div>

            <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] mb-6 md:mb-8 reveal-up tracking-[-0.28px] extra-para-vs">
              {translations.internationalDescription}
            </p>

            <div className="flex flex-col gap-4 reveal-up">
              {/* Block 1: Purpose title + intro paragraph */}
              <div className="pb-4 border-b border-[#C6C4C4] reveal-up reveal-delay-2">
                <h3 className="text-[14px] leading-[22px] tracking-[-0.28px] font-semibold extra-para-vs">
                  {translations.internationalPurposeTitle}
                </h3>
                <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] tracking-[-0.28px] extra-para-vs">
                  {translations.internationalPurposeDesc1}
                </p>
              </div>
              {/* Block 2: Item 1 */}
              <div className="pb-4 border-b border-[#C6C4C4] reveal-up reveal-delay-3">
                <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] tracking-[-0.28px] extra-para-vs">
                  {translations.internationalPurposeDesc2}
                </p>
              </div>
              {/* Block 3: Item 2 (no bottom border) */}
              <div className="reveal-up reveal-delay-4">
                <p className="text-[14px] md:text-[11.5px] md:leading-[18px] xl:text-[14px] xl:leading-[22px] leading-[22px] tracking-[-0.28px] extra-para-vs">
                  {translations.internationalPurposeDesc3}
                </p>
              </div>
            </div>

            {/* <div className="mt-2">
              <div id="accordion-open" data-accordion="open">
                <h2
                  id="accordion-open-heading-2 "
                  className="reveal-up"
                >
                  <button
                    type="button"
                    className="flex items-center justify-between w-full py-4 text-[1rem] font-semibold border-b  border-[#AFA07B] mt-[0rem]"
                    data-accordion-target="#accordion-open-body-2"
                    aria-expanded="false"
                    aria-controls="accordion-open-body-2"
                  >
                    Purpose{" "}
                    <img
                      src={
                        !openPanels.panel2
                          ? RedAccordianArrowDown
                          : AccordianArrowUp
                      }
                      alt="Arrow Icon"
                      onClick={() => togglePanel("panel2")}
                    />
                  </button>
                </h2>
                <div
                  id="accordion-open-body-2"
                  className={`${
                    openPanels.panel2
                      ? "animate_animated  animate_fadeInDown"
                      : "hidden"
                  }`}
                >
                  <div className="py-4  ">
                    <p className="text-[14px] mb-4 leading-[22px]">
                      American Fidelity International Ltd.'s goals are based on
                      two basic principles:
                    </p>
                    <ol className="text-[14px] leading-[22px]">
                      <li>
                        1. To provide our international clients with quality
                        products to help meet their financial needs.{" "}
                      </li>
                      <li>
                        2. To help provide our international clients with
                        financial protection solutions.
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div> 
    </div>
  );
};

export default InternationalClientsData;
